import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { withTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router";
import { Link } from "react-router-dom";
import { Loader } from "src/components";
import { DefaultThemeForReactTable } from "src/components/Table";
import { TicketFieldSetting } from "src/sdk/models/Organisation";
import { OrganisationService } from "src/services/OrganisationService";
import { FieldSettingColumns } from "./FieldSettingColumns";

const service = new OrganisationService();
export const FieldsModule = () => {
  const location = useLocation();
  const history = useHistory();

  const [fieldsData, setFieldsData] = useState<[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true)
    if (location){
      setLoading(true);
       getOrganisationById(location.state.id, setFieldsData, setLoading)
    }
     
  }, []);

  const onEditField = (values: TicketFieldSetting) => {
    console.log(values);
    history.push({
      pathname: '/edit-field-setting',
      state: { fields: values, organisations: location.state }
    })
  }

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div style={{ paddingTop: 10, paddingBottom: 20, display: "flex", flexDirection: "row" }}>
              <Link style={{ color: "black" }}
                to="/organisations"
                className="nav_link"
              >
                <h5>Organizations</h5>
              </Link>
              <i className="bi bi-chevron-right"></i>
              <h5 style={{ marginRight: 13, marginLeft: 13 }}>{location.state.name}</h5>
              <i className="bi bi-chevron-right"></i>
              <h5 style={{ marginLeft: 13, opacity: 0.6 }}>Fields List</h5>
            </div>
          </div>
        </div>

        <div style={{ width: "100%" }} >
          <div className="table-responsive">
            <DataTable
              data={fieldsData}
              columns={FieldSettingColumns(onEditField)}
              customStyles={DefaultThemeForReactTable()}
              progressPending={loading}
              progressComponent={<Loader loading={loading} />}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

FieldsModule.propTypes = {

};

export default withTranslation()(FieldsModule);

export const getOrganisationById = (id: number, setFieldsData: any, setLoading: any) => {
  service.getOrganisationById(id)
    .then(function (response) {
      setFieldsData(response.data.item.fieldSettingItems);
 setLoading(false);
    })
    .catch(function (error) {
      console.log("API ERROR");
      console.log(error);
    })
} 